'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * These touch decorators are based on Jan Amann's TouchUtils (MIT License):
 * https://github.com/amannn/amann.me/blob/master/src/utils/TouchUtils.js
 */
var touchInfo = { trackingID: -1, maxDy: 0, maxDx: 0 };

function getTouchDelta(e) {
    if (e.type === 'touchmove' || e.type === 'touchend') {
        var matches = Array.prototype.filter.call(e.changedTouches, function (touch) {
            return touch.identifier === touchInfo.trackingID;
        });

        if (!matches || matches.length !== 1) return undefined;

        var touch = matches[0];
        return { x: touch.pageX - touchInfo.x, y: touch.pageY - touchInfo.y };
    }
    return { x: e.screenX - touchInfo.x, y: e.screenY - touchInfo.y };
}

var decorateTouchStart = exports.decorateTouchStart = function decorateTouchStart(touchStart) {
    return function (e) {
        // e.preventDefault();
        if (touchInfo.trackingID !== -1) return;

        if (e.type === 'touchstart') {
            touchInfo.trackingID = e.changedTouches[0].identifier;
            touchInfo.x = e.changedTouches[0].pageX;
            touchInfo.y = e.changedTouches[0].pageY;
        } else {
            touchInfo.trackingID = 'mouse';
            touchInfo.x = e.screenX;
            touchInfo.y = e.screenY;
        }

        touchInfo.maxDx = 0;
        touchInfo.maxDy = 0;
        touchInfo.history = [{
            x: 0,
            y: 0,
            time: e.timeStamp
        }];

        if (touchStart) touchStart();
    };
};

var decorateTouchMove = exports.decorateTouchMove = function decorateTouchMove(touchMove) {
    return function (e) {
        // e.preventDefault();
        if (touchInfo.trackingID === -1) return;

        var delta = getTouchDelta(e);

        if (!delta) return;

        // A swipe that is mostly horizontal should not scroll the page vertically at all for better UX
        if (Math.abs(delta.y) < Math.abs(delta.x)) {
            e.preventDefault();
        }

        touchInfo.maxDy = Math.max(touchInfo.maxDy, Math.abs(delta.y));
        touchInfo.maxDx = Math.max(touchInfo.maxDx, Math.abs(delta.x));

        // For the computation of the velocity later
        touchInfo.history.push({
            x: delta.x,
            y: delta.y,
            time: e.timeStamp
        });

        // Don't let the history grow too large
        while (touchInfo.history.length > 10) {
            touchInfo.history.shift();
        }

        if (touchMove) touchMove(delta);
    };
};

var decorateTouchEnd = exports.decorateTouchEnd = function decorateTouchEnd(touchEnd) {
    return function (e) {
        // e.preventDefault();
        if (touchInfo.trackingID === -1) return;

        var delta = getTouchDelta(e);

        if (!delta) return;

        touchInfo.trackingID = -1;

        // This is a very simple implementation of calculating the velocity of
        // the gesture. The strategy is to start from the last sample in the history
        // and walk backwards until there's a sample that's at least 30ms and at most
        // 50ms away from the initial sample. This could be improved by taking more
        // samples into consideration. If there's no matching sample, the velocity
        // will be set to zero.
        var velocity = { x: 0, y: 0 };
        var numSamples = touchInfo.history.length;
        if (numSamples > 2) {
            var lastSample = touchInfo.history[numSamples - 1];

            for (var i = numSamples - 2; i > 0; i -= 1) {
                var curSample = touchInfo.history[i];
                var dt = lastSample.time - curSample.time;

                if (dt > 30 && dt < 50) {
                    velocity.x = (lastSample.x - curSample.x) / (dt / 1000);
                    velocity.y = (lastSample.y - curSample.y) / (dt / 1000);
                    break;
                }
            }
        }

        // Clear history
        touchInfo.history = [];

        if (touchEnd) touchEnd(delta, velocity);
    };
};
//# sourceMappingURL=touchUtils.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/touchUtils.js
 ** module id = 589
 ** module chunks = 1
 **/